import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import menDP from "../images/men.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import { DarkModeContext } from "../context/DarkModeContext";

import project1 from "../images/project1.png";
import project2 from "../images/project2.png";
import project3 from "../images/project3.png";
import project4 from "../images/project4.png";
import project5 from "../images/project5.jpeg";
import project6 from "../images/project6.jpeg";

import node from "../images/node-js.png";
import reactIcon from "../images/react.png";
import vue from "../images/vue-js.png";
import js from "../images/javascript.png";
import php from "../images/php.png";
import html from "../images/html5.png";
import css from "../images/CSS3.png";
import aws from "../images/aws.png";
import mysql from "../images/mysql.png";
import mongodb from "../images/mongodb.png";
import next from "../images/next.png";
import Header from "../components/Header";

export default function Home() {
  const { darkMode } = useContext(DarkModeContext);
  const [selectedImage, setSelectedImage] = useState(null);

  const projects = [
    {
      image: project1,
      technologies: ["Node", "React", "React Native"],
      category: "Social Media",
      link: "https://goalmogul.com/"
    },
    {
      image: project2,
      technologies: ["Node", "iOS", "Android"],
      category: "Social Media, Art",
      link: "https://tree.art/"
    },
    {
      image: project3,
      technologies: ["PHP (CodeIgniter)", "jQuery", "JavaScript"],
      category: "Shop",
      link: "https://www.bookmystudio.fr/"
    },
    {
      image: project4,
      technologies: ["Node.js", "React Native"],
      category: "Climate Control",
      link: "https://apps.apple.com/pk/app/envko/id1605823113"
    },
    {
      image: project5,
      technologies: ["Node.js", "React.js", "MongoDB"],
      category: "Education , management",
      link: "https://app.greyled.com/"
    },
    {
      image: project6,
      technologies: ["React.js", "Next.js"],
      category: "content management , real state",
      link: "https://app.engageplatform.ai/login"
    }
  ];

  const technologies = [
    { name: "HTML5", icon: html },
    { name: "CSS3", icon: css },
    { name: "JavaScript", icon: js },
    { name: "PHP", icon: php },
    { name: "React", icon: reactIcon },
    { name: "Node.js", icon: node },
    { name: "Next.js", icon: next },
    { name: "Vue.js", icon: vue },
    { name: "AWS S3", icon: aws },
    { name: "MySQL", icon: mysql },
    { name: "MongoDB", icon: mongodb }
  ];

  const education = [
    {
      title: "BS in Software Engineering",
      institute: "University of Malakand",
      duration: "2014 - 2018",
      side: "left",
      icon: "bi-mortarboard",
      marks: " 3.62/4"
    },
    {
      title: "Intermediate in Engineering",
      institute: "Islamia Model College Timergara",
      duration: "2012 - 2014",
      side: "right",
      icon: "bi-book",
      marks: " 837/1100"
    },

    {
      title: "Metric",
      institute: "Government High School",
      duration: "2010 - 2012",
      side: "left",
      icon: "bi-pencil",
      marks: " 840/1050"
    }
  ];

  const FooterContacts = [
    {
      icon: "bi-whatsapp",
      color: "#25D366",
      link: "https://wa.me/03078005419",
      target: "_blank"
    },
    {
      icon: "bi-envelope-at-fill",
      color: "#EA4335",
      link: "mailto:zahoorulhaq37@gmail.com",
      target: "_blank"
    }
  ];

  const FooterSocialLinks = [
    {
      icon: "bi-linkedin",
      link: "https://www.linkedin.com/in/zahoor-ul-haq-b0058b10a/",
      target: "_blank"
    },
    {
      icon: "bi-twitter-x",
      link: "https://x.com/Zah00rUHhaq",
      target: "_blank"
    },
    {
      icon: "bi-instagram",
      link: "https://www.instagram.com/zahoor_ig?igsh=MWx0ZHhxdHlqMzc2Yg==",
      target: "_blank"
    }
  ];

  return (
    <div
      className={`${darkMode ? "bg-dark text-white" : "bg-light text-dark"} min-vh-100 w-100`}
    >
      <div className="container py-4">
        <Header />

        <div className="row align-items-center px-3 py-5">
          <div className="col-12 col-md-6 text-center text-md-start">
            <h1 className="fw-bold audiowide-regular">Zahoor Ul Haq</h1>
            <div
              className="bg-warning mb-3"
              style={{ height: "3px", width: "300px" }}
            ></div>
            <p className="fs-5">
              Software Engineer and full stack web developer with 3 years
              experience in professional web and mobile applications
              development. Mainly experienced in Nodejs, PHP(Laravel) and
              front-end javascript libraries Reactjs and Vuejs. Provided
              solutions for wide range of problems in web development field from
              third party APIs to database architecture in my short career.{" "}
            </p>
            <div className="mt-4">
              <a
                href="/Zahoor's Resume.pdf"
                download
                className="btn btn-warning px-4 py-2 fw-semibold"
              >
                Download CV <i className="bi bi-download"></i>
              </a>
            </div>
          </div>
          <div className="col-12 col-md-6 text-center mt-4 mt-md-0">
            <img
              className="img-fluid shadow-lg rounded-circle"
              src={menDP}
              alt="Profile"
              style={{ maxWidth: "300px" }}
            />
          </div>
        </div>

        <div className="py-5">
          <h1 className="text-start display-4 fw-bold mb-2">
            Project Portfolio
          </h1>
          <h3 className="text-start text-warning mb-5">
            What I have worked on
          </h3>

          <div className="row g-5">
            {projects.map((project, idx) => (
              <div className="col-12 col-md-6 col-lg-4" key={idx}>
                <div className="portfolio-item position-relative overflow-hidden rounded-4">
                  <img
                    src={project.image}
                    alt={`${project.technologies.join(", ")} ${project.category}`}
                    className="img-fluid w-100"
                    style={{ height: "220px", objectFit: "cover" }}
                  />

                  <div className="portfolio-overlay position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center p-3">
                    <span className="badge bg-warning bg-opacity-75 text-dark fw-bold rounded-pill px-3 py-2 mb-2">
                      {project.technologies.join(" - ")}
                    </span>

                    <span className="badge bg-secondary bg-opacity-75 text-warning rounded-pill px-4 py-2 mb-3 ">
                      {project.category}
                    </span>

                    <div className="d-flex gap-3">
                      <a
                        href={project.link}
                        className="text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="circle-icon">
                          <i className="bi bi-link-45deg"></i>
                        </div>
                      </a>

                      <button
                        onClick={() => setSelectedImage(project.image)}
                        className="border-0 bg-transparent p-0"
                      >
                        <div className="circle-icon">
                          <i className="bi bi-search"></i>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {selectedImage && (
          <div className="image-modal" onClick={() => setSelectedImage(null)}>
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="close-modal-btn"
                onClick={() => setSelectedImage(null)}
              >
                <i className="bi bi-x-lg"></i>
              </button>
              <img
                src={selectedImage}
                alt="Preview"
                className="img-fluid rounded-5"
              />
            </div>
          </div>
        )}

        <div className="py-5">
          <h1 className="text-start display-4 fw-bold mb-2">Technologies</h1>
          <h3 className="text-start text-warning mb-5">What I use</h3>
          <div className="row g-4">
            {technologies.map((tech, idx) => (
              <div className="col-6 col-sm-4 col-md-3" key={idx}>
                <div className="tech-card d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2 gap-sm-3 p-3 border border-secondary rounded bg-transparent text-center text-sm-start">
                  <img
                    src={tech.icon}
                    alt={tech.name}
                    className="tech-icon mb-2 mb-sm-0"
                    style={{ width: "50px", height: "50px" }}
                  />
                  <span className="fs-5 fw-semibold">{tech.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="container py-5">
          <div className="text-center mb-5">
            <h1 className="display-4 fw-bold mb-2 text-start">Education</h1>
            <div
              className="bg-warning"
              style={{ height: "3px", width: "250px" }}
            ></div>
          </div>
          <div className="position-relative">
            <div
              className="d-none d-md-block position-absolute start-50 top-0 h-100 bg-warning opacity-25"
              style={{ width: "5px" }}
            ></div>
            <div className="row g-4">
              {education.map((edu, idx) => (
                <div className="col-12" key={idx}>
                  <div
                    className={`d-flex flex-column flex-md-row align-items-center ${edu.side === "right" ? "flex-md-row-reverse" : ""}`}
                  >
                    <div className="col-12 col-md-5">
                      <div
                        className={`p-4 rounded-4 shadow-sm border-start border-4 border-warning h-100 ${darkMode ? "bg-secondary bg-opacity-25" : "bg-white"}`}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                          <h5 className="fw-bold mb-0 text-nowrap">
                            {edu.title}
                          </h5>
                          <span className="badge bg-warning text-dark px-3">
                            {edu.duration}
                          </span>
                        </div>
                        <h6 className="text-warning mb-3 fw-semibold">
                          {edu.institute}
                        </h6>
                        {edu.marks && (
                          <p className="mb-4 text-secondary p-2 rounded badge bg-warning">
                            Marks : {edu.marks}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-2 d-none d-md-flex justify-content-center">
                      <div
                        className="bg-warning rounded-circle shadow d-flex align-items-center justify-content-center"
                        style={{ width: "45px", height: "45px" }}
                      >
                        <i className={`bi ${edu.icon} text-dark fs-5`}></i>
                      </div>
                    </div>
                    <div className="col-md-5 d-none d-md-block"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <footer
          className={`${darkMode ? "bg-dark text-white" : "bg-light text-dark"} py-5 border-top border-secondary border-opacity-25`}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 d-flex flex-wrap justify-content-center align-items-center gap-3">
                {FooterContacts.map((item, idx) => (
                  <a
                    key={idx}
                    href={item.link || "#"}
                    target={item.target}
                    rel={item.target ? "noopener noreferrer" : undefined}
                    className="text-decoration-none  d-flex align-items-center gap-2 px-3 py-2 "
                  >
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center shadow border"
                      style={{
                        width: "45px",
                        height: "45px",
                        backgroundColor: item.color
                      }}
                    >
                      <i className={`bi ${item.icon} text-white fs-6`}></i>
                    </div>
                    <span
                      className={`fw-semibold small ${darkMode ? "text-white-50" : "text-secondary"}`}
                    >
                      {item.label}
                    </span>
                  </a>
                ))}

                <div
                  className="border-start border-warning border-opacity-75 mx-2"
                  style={{ height: "35px" }}
                ></div>

                {FooterSocialLinks.map((social, idx) => (
                  <a
                    key={idx}
                    href={social.link}
                    target={social.target}
                    rel="noopener noreferrer"
                    className="d-flex align-items-center justify-content-center rounded-circle shadow-sm border"
                    style={{
                      width: "45px",
                      height: "45px",
                      backgroundColor: "#ffc107"
                    }}
                  >
                    <i className={`bi ${social.icon} fs-5 text-dark`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
